

















































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch, Prop, Ref } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import DateField from "@/components/misc/DateField.vue";
import TimeField from "@/components/misc/TimeField.vue";
import _ from "lodash";
import { Country } from "@/shared/models/country";
import {
  CheckStatusEnum,
  eVisitorCityTaxPaymentCategoriesEnum,
  ReservationCheckInCustomerData,
} from "./CheckinTypes";
import { CityTaxCategory } from "@/shared/models/cityTaxCategory";
import { ArrivalOrganizationType } from "@/shared/models/arrivalOrganizationType";
import { GlobalFilterProperty } from "@/store/modules/globalFilters";
import { ListModel } from "@/shared/models/listModel";
import { City } from "@/shared/models/city";
import {
  EVisitorFacility,
  EVisitorFacilityService,
  eVisitorFacilityServiceFactory,
} from "./eVisitorFacilityService";
import { Notification } from "@/store/modules/notifications";
import { IdentificationDocumentType } from "@/shared/models/identificationDocumentType";
import { DateTime } from "luxon";
import { ArrivalReason } from "@/shared/models/arrivalReason";
import {
  EVisitorIntegrationEnum,
  EVisitorIntegrationNameEnum,
} from "@/shared/models/enums.type";
import { EVisitorIntegrationModel } from "@/shared/models/eVisitor";
import LoadingOverlay from "@/components/misc/LoadingOverlay.vue";

@Component({ components: { RightDrawer, DateField, TimeField, LoadingOverlay } })
export default class CheckInOutEditForm extends Vue {
  @Prop() checkInCustomerDataId?: number;
  @Prop({ default: false }) open!: boolean;
  @Prop({ default: false }) setGuestCheckedIn!: boolean;
  @Prop({ default: null }) defaultArrivalDate!: string | null;
  @Prop({ default: null }) defaultDepartureDate!: string | null;
  @Prop({ default: null }) defaultDepartureTime!: string | null;
  @Prop({ default: false }) explicitCheckinButtonNames!: boolean;

  @Action("codebooks/refreshIdentificationDocumentTypes")
  refreshIdentificationDocumentTypes?: () => Promise<void>;
  @Getter("codebooks/identificationDocumentTypes")
  identificationDocumentTypes?: IdentificationDocumentType[];
  @Action("codebooks/refreshArrivalReasons")
  refreshArrivalReasons?: () => Promise<void>;
  @Getter("codebooks/arrivalReasons") arrivalReasons?: ArrivalReason[];

  @Getter("language/language") language?: string;
  @Action("codebooks/refreshCountries") refreshCountries?: () => Promise<void>;
  @Getter("codebooks/countries") _countries?: Country[];
  get countries() {
    const countriesList =
      this._countries?.map((x) => ({
        id: x.id,
        text: this.language === "hr-HR" ? x.name : x.englishName,
      })) ?? [];

    return _.sortBy(countriesList, (x) => x.text);
  }

  fkey = 0;

  @Watch("open", { immediate: true })
  openWatch(fresh: boolean, old: boolean) {
    if (fresh && !old) {
      this.fkey++;
      this.changedWithEVisitorNotSynced = false;
    }

    if (fresh && this.checkInCustomerDataId) {
      this.load();
      this.initialCheckInCustomerData = new ReservationCheckInCustomerData();
    } else {
      this.checkInCustomerData = new ReservationCheckInCustomerData();
      this.initialCheckInCustomerData = _.cloneDeep(this.checkInCustomerData);
    }
  }

  eVisitorCheck = true;

  eVisitorFacilityService: EVisitorFacilityService | null = null;

  loading = false;
  saving = false;

  eVisitorIntegrationEnum = EVisitorIntegrationEnum;
  @Getter("appParams/tenantEVisitorIntegration")
  eVisitorIntegration?: EVisitorIntegrationModel;

  get eVisitorIntegrationId() {
    return this.eVisitorIntegration?.id ?? EVisitorIntegrationEnum.None;
  }
  get eVisitorIntegrationName() {
    return this.eVisitorIntegration?.name ?? EVisitorIntegrationNameEnum.None;
  }

  get showEvisitor() {
    return this.eVisitorIntegration?.id !== EVisitorIntegrationEnum.None;
  }

  get checkInEVisitorLabel() {
    if (this.explicitCheckinButtonNames) {
      return "Check in on eVisitor";
    }

    return "Check in";
  }

  get checkOutEVisitorLabel() {
    if (this.explicitCheckinButtonNames) {
      return "Checkout on eVisitor";
    }

    return "Check out";
  }

  eVisitStar(fieldName: string) {
    if (
      this.eVisitorCheck &&
      this.eVisitorIntegrationId !== EVisitorIntegrationEnum.None
    ) {
      if (this.eVisitorIntegrationId === EVisitorIntegrationEnum.HR) return "*";
      if (this.eVisitorIntegrationId === EVisitorIntegrationEnum.SL) {
        const required = [
          "genderId",
          "dateOfBirth",
          "countryOfResidenceId",
          "identificationDocumentTypeId",
          "identificationDocumentNumber",
          "eVisitorPaymentCategoryId",
          "checkInDate",
          "checkOutDate",
          "eVisitorCheckInTime",
          "eVisitorCheckOutTimeViewField",
          "propertyId",
          "eVisitorFacilityId",
        ];

        return required.includes(fieldName) ? "*" : "";
      }
    }

    return "";
  }

  checkInCustomerData: ReservationCheckInCustomerData =
    new ReservationCheckInCustomerData();

  initialCheckInCustomerData: ReservationCheckInCustomerData =
    new ReservationCheckInCustomerData();

  isFormValid = false;
  get submitDisabled(): boolean {
    return this.isFormValid && !this.loading && !this.saving;
  }
  get submitCheckInDisabled(): boolean {
    return !this.loading && !this.saving;
  }

  mounted() {
    this.eVisitorFacilityService = eVisitorFacilityServiceFactory(this);
  }

  async created() {
    const promises = [];

    if (
      (!this.countries || this.countries.length == 0) &&
      this.refreshCountries
    ) {
      promises.push(this.refreshCountries());
    }
    if (
      (!this.identificationDocumentTypes ||
        this.identificationDocumentTypes.length == 0) &&
      this.refreshIdentificationDocumentTypes
    ) {
      promises.push(this.refreshIdentificationDocumentTypes());
    }

    if (
      (this.arrivalReasons?.length ?? 0) === 0 &&
      this.refreshArrivalReasons
    ) {
      promises.push(this.refreshArrivalReasons());
    }

    await Promise.all(promises);
  }

  get rules() {
    const required = (value: any) => !!value || this.$t("Validation.Required");
    const requiredForEVisitor = (value: any) =>
      !!value ||
      this.$t("Validation.eVisitorRequired", {
        eVisitorServiceName: this.eVisitorIntegrationName,
      });
    const requiredIfEVisitor = (value: any) => {
      let r;
      if (this.eVisitorCheck) {
        r = requiredForEVisitor(value);
      } else {
        r = required(value);
      }
      return this.eVisitorCheck ? r : true;
    };
    const maxLength = (max: number) => (value: string) =>
      !value ||
      value.length <= max ||
      this.$t("Validation.MaxLength", { count: max });

    const requiredGender = (value: number) => {
      //only male(1) or female(2) should be accepted for eVisitor
      if (value != 1 && value != 2) {
        value = 0;
      }
      const r = required(value);
      return this.eVisitorCheck ? r : true;
    };

    return {
      firstName: [required, maxLength(50)],
      lastName: [required, maxLength(50)],
      email: [
        maxLength(100),
        (value: string) =>
          !value ||
          /^$|.+@.+\..+/.test(value) ||
          this.$t("Validation.EmailFormat"),
      ],
      telephoneNumber: [maxLength(100)],
      streetName: [maxLength(100)],
      houseNumber: [maxLength(10)],
      city: [maxLength(50)],
      identificationDocumentNumber: [maxLength(50), requiredIfEVisitor],
      required: required,
      gender: [requiredGender],
      eVisitorRequired: [requiredIfEVisitor],
      eVisitorRequiredBool: requiredIfEVisitor,
      eVisitorFacilityIdOnProperty: (selectedPropertyId: any) => (val: any) => {
        const shouldValidate =
          this.eVisitorCheck &&
          this.checkStatus === CheckStatusEnum.Neprijavljen;
        const hasFacility = this.eVisitorFacilities(selectedPropertyId)?.some(
          (y) => y.id === val
        );
        return !shouldValidate || hasFacility;
      },
      reason: [
        (v: string) => {
          const r = required(v);
          return this.reasonOpen ? r : true;
        },
      ],
      dateTimesOrder: () => {
        // Validation.SetCheckedInCustomers.CheckInDateTimeMustBeLessThanCheckOut
        if (this.checkInCustomerData) {
          const allAreSet =
            this.checkInDate &&
            this.checkInCustomerData.eVisitorCheckInTime &&
            this.checkOutDate &&
            this.checkInCustomerData.eVisitorExpectedCheckoutTime;

          if (!allAreSet) {
            // there is required validator for this cases
            return true;
          } else {
            const from =
              this.checkInDate?.substr(0, 10) +
              (this.checkInCustomerData.eVisitorCheckInTime ?? "00:00");
            const to =
              this.checkOutDate?.substr(0, 10) +
              (this.checkInCustomerData.eVisitorCheckOutTimeViewField ??
                this.checkInCustomerData.eVisitorExpectedCheckoutTime ??
                "00:00");

            return from > to
              ? this.$t(
                  "Validation.SetCheckedInCustomers.CheckInDateTimeMustBeLessThanCheckOut"
                ).toString()
              : true;
          }
        }

        return true;
      },
    };
  }

  @Ref("form") form?: { validate: () => boolean };

  load() {
    this.loading = true;
    Vue.axios
      .get<any>(
        "reservations/" + this.checkInCustomerDataId + "/getSingleGuest"
      )
      .then((res) => {
        this.checkInCustomerData = Object.assign(
          new ReservationCheckInCustomerData(),
          res.data
        );

        this.checkInCustomerData.isEmpty = false;
        this.eVisitorCheck =
          this.checkInCustomerData.eVisitorIsCheckedIn ?? false;

        if (
          this.checkInCustomerData &&
          !this.checkInCustomerData.eVisitorFacilityId &&
          !this.checkInCustomerData.eVisitorFacilityPropertyId
        ) {
          this.checkInCustomerData.eVisitorFacilityPropertyId =
            this.checkInCustomerData.reservationPropertyId;
          this.checkInCustomerData.eVisitorFacilityId = null;
        }

        if (
          this.checkInCustomerData &&
          !this.checkInCustomerData.checkInDate &&
          this.defaultArrivalDate !== null
        ) {
          this.checkInCustomerData.checkInDate = this.defaultArrivalDate;
        }

        if (
          this.checkInCustomerData &&
          !this.checkInCustomerData.checkOutDate &&
          this.defaultDepartureDate !== null
        ) {
          this.checkInCustomerData.checkOutDate = this.defaultDepartureDate;
        }

        if (!this.checkInCustomerData.eVisitorCheckInTime) {
          this.checkInCustomerData.eVisitorCheckInTime = DateTime.local()
            .toISOTime()
            .substring(0, 5);
        }

        if (
          !this.checkInCustomerData.eVisitorCheckoutTime &&
          !this.checkInCustomerData.eVisitorExpectedCheckoutTime &&
          this.defaultDepartureTime !== null
        ) {
          const checkoutTime = this.defaultDepartureTime;

          this.checkInCustomerData.eVisitorCheckoutTime = checkoutTime;
          this.checkInCustomerData.eVisitorExpectedCheckoutTime = checkoutTime;
        }

        this.checkInCustomerData.eVisitorCheckOutTimeViewField = this
          .checkInCustomerData.isCheckedOut
          ? this.checkInCustomerData.eVisitorCheckoutTime
          : this.checkInCustomerData.eVisitorExpectedCheckoutTime;

        this.initialCheckInCustomerData = _.cloneDeep(this.checkInCustomerData);
        this.refreshNumberOfFilledBeds();
      })
      .finally(() => {
        this.loading = false;
      });
  }

  assertFormValidity() {
    const valid = this.form?.validate();

    if (!valid) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("Changes are invalid or incomplete"),
        timeout: 5000,
      });
    }

    return valid;
  }

  async submit() {
    if (this.checkStatus == CheckStatusEnum.Neprijavljen) {
      //this will reset validation to only look at customer validation
      this.eVisitorCheck = false;
    }
    if (this.assertFormValidity()) {
      await this.saveCustomerData();
      await this.checkInReservationUpdate();
      this.load();
    }
  }

  changedWithEVisitorNotSynced = false;
  get changePendingMessage() {
    // prettier-ignore
    return this.changedWithEVisitorNotSynced
      ? this.$t("Changes not synced with eVisitor. Are you sure you want to close the form?", {eVisitorServiceName: this.eVisitorIntegrationName})
      : this.$t("Changes pending. Are you sure you want to close the form?");
  }

  async checkInReservationUpdate() {
    this.saving = true;
    await Vue.axios
      .post(`reservations/ReservationUpdateForMultipleGuestIds`, {
        guestIds: [this.checkInCustomerData.id],
      })
      .then(() => {
        this.$emit("refreshTable");
      })
      .finally(() => {
        this.saving = false;
      });
  }

  async saveCustomerData() {
    this.saving = true;

    function nullIfEmpty(x: string | null | undefined) {
      return x === "" ? null : x ?? null;
    }

    this.checkInCustomerData.eVisitorArrivalOrganizationTypeId =
      this.eVisitorArrivalOrganizationTypeId;
    this.checkInCustomerData.eVisitorFacilityPropertyId = this.propertyId;
    this.checkInCustomerData.eVisitorPaymentCategoryId =
      this.eVisitorPaymentCategoryId;
    this.checkInCustomerData.dateOfBirth = nullIfEmpty(
      this.checkInCustomerData.dateOfBirth
    );
    this.checkInCustomerData.checkInDate = nullIfEmpty(this.checkInDate);
    this.checkInCustomerData.checkOutDate = nullIfEmpty(this.checkOutDate);
    this.checkInCustomerData.eVisitorCheckInTime = nullIfEmpty(
      this.checkInCustomerData.eVisitorCheckInTime
    );
    this.checkInCustomerData.eVisitorCheckoutTime = nullIfEmpty(
      this.checkOutTime
    );
    this.checkInCustomerData.eVisitorExpectedCheckoutDate = nullIfEmpty(
      this.checkInCustomerData.eVisitorExpectedCheckoutDate ?? this.checkOutDate
    );
    this.checkInCustomerData.eVisitorExpectedCheckoutTime = nullIfEmpty(
      this.checkInCustomerData.eVisitorExpectedCheckoutTime
    );

    if (this.setGuestCheckedIn) {
      this.checkInCustomerData.isCheckedIn = true;
    }

    await Vue.axios
      .post("reservations/updateReservationGuest", this.checkInCustomerData)
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("SaveCheckInGuest.SaveSuccess"),
          timeout: 5000,
        });
        this.checkInCustomerData.isDirty = false;

        if (this.checkStatus !== CheckStatusEnum.Prijavljen) {
          // initialCheckInCustomerData should be used to detect changes
          // special case when checkStatus == 2 is that we are still not "done"
          // as we need to sync with eVisitor
          this.initialCheckInCustomerData = _.cloneDeep(
            this.checkInCustomerData
          );
        }

        this.changedWithEVisitorNotSynced = true;

        this.$emit("saved", this.checkInCustomerDataId);
      })
      .finally(() => {
        this.saving = false;
      });
  }

  async checkIn() {
    this.eVisitorCheck = true;

    if (this.assertFormValidity()) {
      await this.confirmCheckIn();
      await this.checkInReservationUpdate();
      this.load();
    }
  }

  async confirmCheckIn() {
    this.checkInCustomerData.eVisitorCheckInDate = this.checkInDate;
    await this.saveCustomerData();

    this.saving = true;
    await Vue.axios
      .post("reservations/" + this.checkInCustomerData?.id + "/checkInGuest")
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("CheckInGuest.SaveSuccess"),
          timeout: 5000,
        });

        this.changedWithEVisitorNotSynced = false;
      })
      .finally(() => {
        this.saving = false;
      });
  }

  async checkOut() {
    if (this.assertFormValidity()) {
      try {
        await this.confirmCheckOut();
      } catch (ex) {
        const isErrorHandled =
          ex?.data?.brokenRules?.length === 1 &&
          (ex.data.brokenRules[0].name ===
            "EVisitor.CheckOut.AlreadyCheckedOut" ||
            ex.data.brokenRules[0].name ===
              "EVisitor.CheckOut.CheckInHasBeenCancelled");
        if (isErrorHandled) throw ex;
      }
      await this.checkInReservationUpdate();
      this.load();
    }
  }

  async confirmCheckOut() {
    this.checkInCustomerData.eVisitorCheckoutDate = this.checkOutDate;
    await this.saveCustomerData();

    this.saving = true;
    await Vue.axios
      .post("reservations/" + this.checkInCustomerData?.id + "/checkOutGuest")
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("CheckOutGuest.SaveSuccess"),
          timeout: 5000,
        });
      })
      .finally(() => {
        this.saving = false;
      });
  }

  refreshNumberOfFilledBeds() {
    if (this.propertyId) {
      this.eVisitorFacilityService?.loadGroup(this.propertyId);
    }
  }

  numberOfFilledBeds(facility: EVisitorFacility) {
    let baseline = facility.numberOfCheckedInBeds;
    if (baseline > 0) {
      baseline -=
        this.checkInCustomerData.isCheckedIn &&
        this.initialCheckInCustomerData.eVisitorFacilityId == facility.id
          ? 1
          : 0;
    }
    const selectedOnForm =
      this.checkInCustomerData.eVisitorFacilityId == facility.id &&
      !this.checkInCustomerData.eVisitorIsCheckedOut
        ? 1
        : 0;

    return baseline + selectedOnForm;
  }

  get customerNameAndReservation() {
    return (
      this.checkInCustomerData?.firstName +
      " " +
      this.checkInCustomerData?.lastName +
      " (" +
      this.checkInCustomerData?.reservationId +
      ")"
    );
  }

  get checkInOutStatusText() {
    if (this.checkStatus == CheckStatusEnum.Prijavljen) {
      return this.$t("Reservation.Guest.CheckedIn");
    } else if (this.checkStatus == CheckStatusEnum.Odjavljen) {
      return this.$t("Reservation.Guest.CheckedOut");
    } else {
      return this.$t("Pending");
    }
  }

  //magic numbers: 1 - neprijavljen, 2 - prijavljen, 3 - odjavljen
  get checkStatus() {
    if (
      this.checkInCustomerData?.eVisitorIsCheckedIn &&
      this.checkInCustomerData?.eVisitorIsCheckedOut
    ) {
      return CheckStatusEnum.Odjavljen;
    } else if (
      this.checkInCustomerData?.eVisitorIsCheckedIn &&
      !this.checkInCustomerData?.eVisitorIsCheckedOut
    ) {
      return CheckStatusEnum.Prijavljen;
    } else {
      return CheckStatusEnum.Neprijavljen;
    }
  }

  async updateEVisitorCheckIn() {
    try {
      this.loading = true;
      await this.confirmCheckIn();
      await this.checkInReservationUpdate();
      this.load();
    } finally {
      this.loading = false;
    }
  }

  reason = "";
  reasonTitle = "Cancel check-in on eVisitor reason";
  reasonOpen = false;
  reasonFormValid = false;
  reasonAction = () => Promise.resolve();
  @Ref("reasonForm") reasonForm?: {
    reset: () => void;
    resetValidation: () => void;
    validate: () => boolean;
  };

  revertEVisitorCheckIn() {
    this.reasonForm?.resetValidation();
    this.reason = "";
    this.reasonTitle = "Cancel check-in on eVisitor reason";
    this.reasonOpen = true;
    this.reasonAction = this.revertEVisitorCheckInConfirm;
  }
  async revertEVisitorCheckInConfirm() {
    await this.reset("reservations/cancelEVisitorGuestCheckIn");
    this.load();
  }
  revertEVisitorCheckOut() {
    this.reasonForm?.resetValidation();
    this.reason = "";
    this.reasonTitle = "Cancel check-out on eVisitor reason";
    this.reasonOpen = true;
    this.reasonAction = this.revertEVisitorCheckOutConfirm;
  }
  async revertEVisitorCheckOutConfirm() {
    await this.reset("reservations/cancelEVisitorGuestCheckOut");
    this.load();
  }
  async reset(action: string) {
    this.saving = true;
    await Vue.axios
      .post(action, {
        id: this.checkInCustomerData.id,
        reason: this.reason,
      })
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("EVisitor.SaveSuccess", {
            eVisitorServiceName: this.eVisitorIntegrationName,
          }),
          timeout: 3000,
        });

        this.reasonOpen = false;
        this.refreshNumberOfFilledBeds();
      })
      .finally(() => {
        this.saving = false;
      });

    await this.checkInReservationUpdate();
  }

  formatDate(date: string | Date) {
    if (!date) return null;
    return this.$d(new Date(date));
  }
  parseDate(date: string) {
    if (!date) return null;

    const [month, day, year] = date.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }

  @Getter("globalFilters/properties")
  allUserProperties?: GlobalFilterProperty[];

  get properties() {
    if (!this.allUserProperties) return [] as GlobalFilterProperty[];
    if (this.checkStatus === 1) {
      return _.sortBy(
        this.allUserProperties.filter((x) => x.status !== false),
        (x) => x.name
      );
    }
    return _.sortBy(this.allUserProperties, (x) => x.name);
  }

  eVisitorOpen = -1;

  get isEmpty() {
    return this.checkInCustomerData?.isEmpty ?? true;
  }
  get isDirty() {
    return this.checkInCustomerData?.isDirty ?? false;
  }
  setDirty() {
    if (this.checkInCustomerData) {
      const alreadyDirty = this.checkInCustomerData.isDirty;

      this.checkInCustomerData.isDirty = true;
      this.checkInCustomerData.isEmpty = false;

      if (!alreadyDirty) {
        this.$emit("dirty");
      }
    }
  }

  eVisitorFacilities(eVisitorFacilityPropertyId: number) {
    if (!eVisitorFacilityPropertyId) return [];

    if (this.eVisitorFacilityService) {
      if (
        !this.eVisitorFacilityService.groups.some(
          (x) => x.propertyId === eVisitorFacilityPropertyId
        )
      ) {
        this.eVisitorFacilityService.loadGroup(eVisitorFacilityPropertyId);
      }

      const group = this.eVisitorFacilityService.findGroup(
        eVisitorFacilityPropertyId
      )?.facilities;

      return group;
    }

    return [];
  }

  get sortedEVisitorFacilities() {
    return this.propertyId
      ? _.sortBy(this.eVisitorFacilities(this.propertyId), (g) =>
          g.accountName ? g.accountName : g.facility
        )
      : [];
  }

  @Watch("sortedEVisitorFacilities")
  sortedEVisitorFacilitiesChanged(fresh: EVisitorFacility[]) {
    if (fresh.length === 1) {
      this.checkInCustomerData.eVisitorFacilityId = fresh[0].id;
      this.initialCheckInCustomerData.eVisitorFacilityId = fresh[0].id;
    } else {
      const defaultFacilities = fresh.filter((x) =>
        x.defaultForAccomodationUnitsIds.some(
          (u) => u === this.checkInCustomerData.accomodationUnitId
        )
      );
      if (defaultFacilities.length === 1) {
        this.checkInCustomerData.eVisitorFacilityId = defaultFacilities[0].id;
        this.initialCheckInCustomerData.eVisitorFacilityId =
          defaultFacilities[0].id;
      }
    }
  }

  get eVisitorPaymentCategoryId() {
    if (this.checkInCustomerData) {
      return (
        this.checkInCustomerData?.getEffectiveEVisitorPaymentCategoryId(
          this.eVisitorIntegrationId
        ) ?? null
      );
    }
    return 1;
  }
  set eVisitorPaymentCategoryId(val: number | null) {
    if (this.checkInCustomerData) {
      this.setDirty();
      this.checkInCustomerData.eVisitorPaymentCategoryId = val;
    }
  }

  get checkInDate() {
    if (this.checkInCustomerData?.eVisitorIsCheckedIn) {
      return this.checkInCustomerData?.eVisitorCheckInDate ?? null;
    } else {
      return this.checkInCustomerData?.checkInDate ?? null;
    }
  }
  set checkInDate(val: string | null) {
    if (this.checkInCustomerData) {
      this.setDirty();
      this.checkInCustomerData.checkInDate =
        this.checkInCustomerData.eVisitorCheckInDate = val ?? null;
    }
  }

  get checkOutDate() {
    if (this.checkInCustomerData?.eVisitorIsCheckedOut) {
      return this.checkInCustomerData?.eVisitorCheckoutDate ?? null;
    } else if (this.checkInCustomerData?.eVisitorIsCheckedIn) {
      return this.checkInCustomerData?.eVisitorExpectedCheckoutDate ?? null;
    } else {
      return this.checkInCustomerData?.checkOutDate ?? null;
    }
  }
  set checkOutDate(val: string | null) {
    if (this.checkInCustomerData) {
      this.setDirty();
      this.checkInCustomerData.checkOutDate =
        this.checkInCustomerData.eVisitorCheckoutDate =
        this.checkInCustomerData.eVisitorExpectedCheckoutDate =
          val ?? null;
    }
  }

  get checkOutTime() {
    if (this.checkInCustomerData?.eVisitorIsCheckedOut) {
      return this.checkInCustomerData.eVisitorCheckoutTime;
    } else {
      return this.checkInCustomerData?.eVisitorExpectedCheckoutTime ?? null;
    }
  }
  set checkOutTime(val: string | null) {
    if (this.checkInCustomerData) {
      this.setDirty();
      this.checkInCustomerData.eVisitorCheckoutTime =
        this.checkInCustomerData.eVisitorExpectedCheckoutTime = val ?? null;
    }
  }

  get eVisitorArrivalOrganizationTypeId() {
    return this.checkInCustomerData?.eVisitorArrivalOrganizationTypeId ?? 1;
  }
  set eVisitorArrivalOrganizationTypeId(val: number | null) {
    if (this.checkInCustomerData) {
      this.setDirty();
      this.checkInCustomerData.eVisitorArrivalOrganizationTypeId = val;
      this.$emit("organizationTypeIdChanged", val);
    }
  }

  get propertyId() {
    return this.checkInCustomerData.eVisitorFacilityPropertyId;
  }
  set propertyId(val: number | null) {
    if (this.checkInCustomerData) {
      this.setDirty();
      if (this.checkInCustomerData.eVisitorFacilityPropertyId !== val) {
        this.checkInCustomerData.eVisitorFacilityPropertyId = val;
        this.checkInCustomerData.eVisitorFacilityId = null;
      }
      this.form?.validate();
    }
  }

  onDateOfBirthChange() {
    if (this.checkInCustomerData.dateOfBirth) {
      const age = DateTime.local().diff(
        DateTime.fromISO(this.checkInCustomerData.dateOfBirth),
        "years"
      ).years;

      if (this.eVisitorIntegrationId == EVisitorIntegrationEnum.HR) {
        if (age <= 12) {
          this.eVisitorPaymentCategoryId =
            eVisitorCityTaxPaymentCategoriesEnum.DijeteDo12;
        } else if (age <= 18) {
          this.eVisitorPaymentCategoryId =
            eVisitorCityTaxPaymentCategoriesEnum.Dijete12Do18;
        } else if (
          this.eVisitorPaymentCategoryId ===
            eVisitorCityTaxPaymentCategoriesEnum.Dijete12Do18 ||
          this.eVisitorPaymentCategoryId ===
            eVisitorCityTaxPaymentCategoriesEnum.DijeteDo12
        ) {
          this.eVisitorPaymentCategoryId =
            eVisitorCityTaxPaymentCategoriesEnum.Turist;
        }
      } else if (this.eVisitorIntegrationId == EVisitorIntegrationEnum.SL) {
        if (age <= 7)
          this.eVisitorPaymentCategoryId =
            eVisitorCityTaxPaymentCategoriesEnum.Exemption_ChildUpTo7_SL_eTurizem;
        else if (age <= 18)
          this.eVisitorPaymentCategoryId =
            eVisitorCityTaxPaymentCategoriesEnum.HalfPayment_PersonAged7To18_SL_eTurizem;
        else if (
          this.eVisitorPaymentCategoryId ===
            eVisitorCityTaxPaymentCategoriesEnum.Exemption_ChildUpTo7_SL_eTurizem ||
          this.eVisitorPaymentCategoryId ===
            eVisitorCityTaxPaymentCategoriesEnum.HalfPayment_PersonAged7To18_SL_eTurizem
        ) {
          this.eVisitorPaymentCategoryId =
            eVisitorCityTaxPaymentCategoriesEnum.FullPayment_NoException_SL_eTurizem;
        }
      }
    }
  }

  isCitiesLoading = false;
  citiesSearch = "" as string | null | undefined;
  cities = [] as City[];

  @Watch("checkInCustomerData.city")
  citiesSearchChanged(
    fresh: string | null | undefined,
    old: string | null | undefined
  ) {
    if (!fresh || fresh === "" || fresh === old) return;

    this.debouncedCitySearch(fresh);
  }

  debouncedCitySearch = _.debounce(this.loadCities, 500);

  async loadCities(search: string | null | undefined): Promise<City[]> {
    this.isCitiesLoading = true;

    this.citiesSearch = search;

    return this.axios
      .get<ListModel<City>>("/codebooks/cities", {
        params: {
          name: this.citiesSearch,
          $top: 50,
          $skip: 0,
          $orderBy: "name asc",
        },
      })
      .then(({ data }) => {
        this.cities = data.result;
        return this.cities;
      })
      .finally(() => {
        this.isCitiesLoading = false;
        this.setCTCategory();
      });
  }

  setCTCategory() {
    if (
      this.checkInCustomerData?.countryOfResidenceId === 1 &&
      this.eVisitorIntegrationId == EVisitorIntegrationEnum.HR
    ) {
      const selectedProperty = this.properties.find(
        (x) => x.propertyId == this.propertyId
      );
      if (selectedProperty) {
        const propertyCityName = selectedProperty.postalCodeAndCity
          .split(",")[1]
          .trim();
        if (propertyCityName === this.checkInCustomerData.city) {
          this.setEvisitorPaymentCategoryIdWithoutDirty(
            eVisitorCityTaxPaymentCategoriesEnum.Lokalac
          );
        }
      }
    }
  }

  setEvisitorPaymentCategoryIdWithoutDirty(val: number) {
    if (this.checkInCustomerData) {
      this.checkInCustomerData.eVisitorPaymentCategoryId = val;
    }
  }

  @Getter("codebooks/cityTaxCategories") cityTaxCategories?: CityTaxCategory[];
  @Getter("codebooks/arrivalOrganizationTypes")
  arrivalOrganizationTypes?: ArrivalOrganizationType[];

  expandOnError(evt: boolean) {
    if (evt) {
      this.eVisitorOpen = 0; // 0 is the first(only) element
    }
  }

  closeModal() {
    if (!this.isDirty) {
      this.$emit("update:open", false);
    } else {
      this.$store.dispatch("showNotification", {
        color: "warning",
        message: this.$t(
          "Changes pending. Are you sure you want to close the form?"
        ),
        actions: [
          {
            text: this.$t("Close"),
            fun: () => {
              this.$emit("update:open", false);
              return true;
            },
          },
          {
            text: this.$t("Cancel"),
            fun: () => {
              return true;
            },
          },
        ],
        timeout: 30000,
      } as Notification);
    }
  }
}
